import React, { useState } from 'react';
import JunoClientSnackbar from '../../client/Juno/client/components/global/JunoClientSnackbar';
import { getShortName, useJunoCommonFunctions } from '../../client/Juno/helpers';
import { useSelector } from 'react-redux';
import LogoutIcon from '@mui/icons-material/Logout';
import { ACC_SETTINGS_MENU } from '../helpers/constant';
import ProfilePageMobileView from '../components/profile/ProfilePageMobileView';
import { Avatar } from '@mui/material';

const ProfilePage = () => {
    const [activeTab, setActiveTab] = useState(ACC_SETTINGS_MENU[0]?.id);
    const { logout, useWindowWidth } = useJunoCommonFunctions();

    const clientData = useSelector(state => state.juno.clientData);
    const { name, readOnly, accountRole } = clientData ? clientData : { name: '-' };

    const allowedMenus = ACC_SETTINGS_MENU.filter(menu => {
        return (readOnly && (menu.id == 'securitySettings' || menu.id == 'additionalAccounts')) ||
            (accountRole == 'user' && menu.id == 'additionalAccounts')
            ? false
            : true;
    });

    const activeComponent = allowedMenus.find(item => item.id === activeTab)?.component;

    const windowWidth = useWindowWidth();

    return (
        <>
            {windowWidth <= 1100 ? (
                <ProfilePageMobileView />
            ) : (
                <>
                    {' '}
                    <JunoClientSnackbar />
                    <div className="flex flex-row bg-card-bg  !gap-[4px] w-full h-full dark:bg-container-bg !px-[0.25rem] lg:mt-[3px]">
                        {/* Left Section - Content */}
                        <div className="w-[25%] bg-modal-bg flex flex-col border border-[#0000001F] dark:!border-white/5 rounded-lg">
                            {/* Header */}
                            <h1 className="text-text text-sm font-medium leading-5  !px-6 !py-4 uppercase">
                                Account Settings
                            </h1>

                            <div className="p-6 pt-3 flex flex-col flex-grow ">
                                <div className="flex items-center gap-3 mb-6">
                                    <Avatar
                                        imgProps={{
                                            style: {
                                                objectFit: 'fill',
                                            },
                                        }}
                                        src={clientData?.profileImage?.url}
                                        variant="square"
                                        sx={{
                                            width: '54px',
                                            height: '52px',
                                            borderRadius: '0.375rem',
                                            outline: '1px solid',
                                            outlineColor: 'var(--color-text)',
                                        }}>
                                        <p className="flex p-3 flex-col justify-center items-center gap-3 rounded-lg bg-buttons-tx-modal-bg text-container-bg uppercase  font-semibold">
                                            {getShortName(name)}
                                        </p>
                                    </Avatar>

                                    <div className="flex flex-col gap-1">
                                        <p className="text-text text-sm font-semibold leading-5 uppercase">
                                            {clientData?.name}
                                        </p>
                                        <p className="text-sm font-medium leading-5  text-balanceCard-manage uppercase">
                                            Account NR: {clientData?.accountNumber}
                                        </p>
                                    </div>
                                </div>

                                {/* Navigation menu */}
                                <div className="flex flex-col flex-grow justify-between">
                                    <div className=" rounded-[6px] bg-card-bg">
                                        <ul className="flex flex-col justify-start items-start gap-2 !p-5 ">
                                            {allowedMenus.map((item, index) => (
                                                <li
                                                    key={item.id}
                                                    className="w-full list-square uppercase">
                                                    <button
                                                        onClick={() => setActiveTab(item.id)}
                                                        className={`w-full text-left py-2 px-3 ${
                                                            activeTab === item.id
                                                                ? 'font-semibold text-[#1A8A7E]'
                                                                : 'text-[#71717A] dark:text-[#D1D1D6]'
                                                        }`}>
                                                        <div
                                                            data-e2e={item.label}
                                                            className="flex gap-2 items-center uppercase font-inter font-medium text-sm leading-5">
                                                            {activeTab === item.id && (
                                                                <div className="w-1 h-1 bg-[#1A8A7E]"></div>
                                                            )}
                                                            {item.label}
                                                        </div>
                                                    </button>
                                                    {/* Custom divider */}
                                                    {index != allowedMenus?.length - 1 ? (
                                                        <div className="h-px bg-divider-text w-full" />
                                                    ) : null}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div
                                        className="flex flex-row justify-between items-center !p-5 gap-4 rounded-[6px] bg-card-bg mt-4 cursor-pointer"
                                        onClick={logout}>
                                        <p
                                            className="text-badge-text-pending text-sm font-medium leading-5 uppercase"
                                            data-e2e="log-out-btn">
                                            Log Out
                                        </p>
                                        <LogoutIcon className="text-badge-text-pending" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Section - Content */}
                        <div className="w-full rounded-lg bg-modal-bg border border-[#0000001F] dark:!border-white/5">
                            {activeComponent}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default ProfilePage;
